export const mentionslegalesTranslations = {
  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_current: 'Mentions légales',
  hero_h1: 'Mentions légales',
  hero_date: 'Dernière mise à jour : 16 mai 2026',

  // Éditeur
  editeur_h2: 'Éditeur du site',
  editeur_raison: 'Raison sociale',
  editeur_raison_val: 'Couvreur-Lévis.com - Plateforme de mise en relation',
  editeur_statut: 'Statut juridique',
  editeur_statut_val: 'Travailleur autonome',
  editeur_adresse: 'Adresse',
  editeur_adresse_val: 'Lévis, QC, Canada',
  editeur_tel: 'Téléphone',
  editeur_tel_val: '418-476-9950',
  editeur_email: 'Courriel',
  editeur_email_val: 'contact@couvreur-levis.com',
  editeur_neq: "Numéro d'entreprise du Québec (NEQ)",
  editeur_neq_val: "En cours d'enregistrement",

  // Hébergement
  hebergement_h2: "Hébergement du site",
  hebergement_nom: "Hébergeur",
  hebergement_nom_val: 'Infomaniak Network SA',
  hebergement_adresse: 'Adresse',
  hebergement_adresse_val: 'Rue Eugène-Marziano 25, 1227 Les Acacias, Genève, Suisse',
  hebergement_site: 'Site web',
  hebergement_site_val: 'https://www.infomaniak.com',

  // Propriété intellectuelle
  pi_h2: 'Propriété intellectuelle',
  pi_text: "L'ensemble du contenu du site couvreur-levis.com (textes, images, logos, graphismes) est protégé par les lois canadiennes et internationales sur le droit d'auteur. Toute reproduction, même partielle, sans autorisation écrite préalable est interdite.",

  // Responsabilité
  responsabilite_h2: 'Limitation de responsabilité',
  responsabilite_text: "Couvreur-Lévis.com met tout en oeuvre pour assurer l'exactitude des informations diffusées. Les prix indicatifs peuvent varier selon les projets. Seule une soumission écrite signée fait foi des prix réels. Couvreur-Lévis.com est un service de mise en relation et n'exécute pas directement les travaux de toiture. Les travaux sont réalisés par nos couvreurs partenaires indépendants, tous certifiés RBQ.",

  // Liens externes
  liens_h2: 'Liens vers des sites tiers',
  liens_text: "Le site peut contenir des liens vers des sites tiers. Couvreur-Lévis.com n'est pas responsable du contenu de ces sites externes.",

  // Droit applicable
  droit_h2: 'Droit applicable',
  droit_text: 'Les présentes mentions sont régies par le droit québécois. Tout litige relève des tribunaux du district judiciaire de Québec.',

  // Contact
  contact_h2: 'Nous contacter',
  contact_text: "Pour toute question concernant les mentions légales, contactez-nous à contact@couvreur-levis.com ou au 418-476-9950.",

  // Shared
  phone_number: '418-476-9950',
};

export default mentionslegalesTranslations;